export default __webpack_public_path__ + "static/media/151-industrial-park.cd8c5790.png";